export default "__VITE_ASSET__DDKCFSq7__"